type Props = {
    children?: JSX.Element
};

export default function AvatarImage(props: Props)
{
    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {props.children}
        </>
    );
}
